export const setMyValue = (value) => {
    console.log(value,"jkl")
    return {
      type: 'SET_MY_VALUE',
      payload: value,
    };
  };